export const PRODUCTION = true;
export const PRODUCTION_ = false;

export const FE_BASE_URI = PRODUCTION ? "https://littlecoders.dev/" : "http://localhost:3000/"

// para los php
export const BASE_URI = PRODUCTION ? "https://littlecoders.dev/" : "http://localhost:8010/"
export const BACK_URI = "https://ofertas.wiki/portal/"
